import thdCustomer from '@thd-olt-global/thd-customer';
import { isMobile } from 'react-device-detect';
import { api } from './base';
import { getTMXSessionID, checkFSEnabled } from '../utils';

export function getCustomerRecentActivity() {
  const namespaces = 'identity,security';
  const activityFSEnabled = checkFSEnabled('ENABLE_NEW_ACTIVITY_API');
  const namespaceEnabled = checkFSEnabled('ENABLE_NAMESPACES');
  const endpointURL = namespaceEnabled
    ? `/customer/account/v1/${thdCustomer?.userID}/activity?namespaces=${namespaces}`
    : `/customer/account/v1/${thdCustomer?.userID}/activity`;
  const activityURL = activityFSEnabled
    ? `/customer/account/v1/activity?namespaces=${namespaces}`
    : endpointURL;
  const activityRequest = {
    method: 'get',
    url: activityURL,
    headers: {
      Accept: 'application/json',
      Channelid: isMobile ? '2' : '1',
      Authorization: thdCustomer.jwt,
      TMXProfileID: getTMXSessionID(),
      ClientOrigin: window.location.origin
    },
  };

  return api(activityRequest)
    .then((res) => {
      return res?.data?.events;
    })
    .catch(() => {
      return null;
    });
}
